import p5 from "p5";
import vertSrc from "./shader.vert?raw";
import fragSrc from "./shader.frag?raw";

export class DistortApp {
  private p?: any;
  private container: HTMLElement | null = null;
  private shaderProgram?: any;
  private textGraphic?: any;

  // 枠の右側に表示する絵文字（必要に応じて変更OK）
  private emoji = "🫠";

  initialize(): void {
    this.container = document.getElementById("p5-container");
    if (!this.container) throw new Error("#p5-container が見つかりません");

    const sketch = (p: any) => {
      p.setup = () => {
        const canvas = p.createCanvas(p.windowWidth, p.windowHeight, p.WEBGL);
        canvas.parent(this.container!);
        p.pixelDensity(1);
        p.noStroke();
        p.rectMode(p.CORNER);

        this.shaderProgram = p.createShader(vertSrc, fragSrc);

        this.textGraphic = p.createGraphics(p.width, p.height);
        this.textGraphic.pixelDensity(1);
        this.redrawTextTexture(p);

        // Webフォント読み込み後に再描画（本文フォントのみ）
        if ((document as any).fonts && (document as any).fonts.load) {
          (document as any).fonts
            .load('400 16px "BBH Sans Bartle"')
            .then(() => {
              this.redrawTextTexture(p);
            })
            .catch(() => {});
        }
      };

      p.draw = () => {
        if (!this.shaderProgram) return;
        p.shader(this.shaderProgram);

        // ユニフォーム名をシェーダに合わせる
        this.shaderProgram.setUniform("u_texture", this.textGraphic);
        this.shaderProgram.setUniform("u_resolution", [p.width, p.height]);
        this.shaderProgram.setUniform("u_mouse", [p.mouseX / p.width, 1.0 - p.mouseY / p.height]);
        this.shaderProgram.setUniform("u_intro_time", p.millis());

        p.rect(-p.width / 2, -p.height / 2, p.width, p.height);
      };

      p.windowResized = () => {
        p.resizeCanvas(p.windowWidth, p.windowHeight);
        this.textGraphic = p.createGraphics(p.width, p.height);
        this.textGraphic.pixelDensity(1);
        this.redrawTextTexture(p);
      };
    };

    this.p = new p5(sketch);
  }

  destroy(): void {
    if (this.p) {
      this.p.remove();
      this.p = undefined;
    }
  }

  // テキストと枠の描画処理（枠の右側に絵文字を追加）
  private redrawTextTexture(p: any): void {
    if (!this.textGraphic) return;
    const g = this.textGraphic as any;

    const textToRender = "PIXELATE";
    const colorConfig: Record<number, [number, number, number]> = {
      1: [255, 0, 0],
    };
    const defaultColor: [number, number, number] = [255, 255, 255];

    g.clear();
    g.background(0);

    const textSizePx = p.width * 0.05;
    g.textSize(textSizePx);
    g.textFont("BBH Sans Bartle");

    const totalW = g.textWidth(textToRender);
    const startX = g.width / 2 - totalW / 2;
    const yPos = g.height / 2;

    // 枠
    g.noFill();
    g.stroke(255);
    g.strokeWeight(10);
    g.rectMode(p.CENTER);
    const padding = 40;
    g.rect(g.width / 2, yPos, totalW + padding, textSizePx + padding);

    // テキスト本体
    g.noStroke();
    g.textAlign(p.LEFT, p.CENTER);
    let currentX = startX;
    for (let i = 0; i < textToRender.length; i++) {
      const ch = textToRender[i];
      const color = colorConfig[i] || defaultColor;
      g.fill(color[0], color[1], color[2]);
      g.text(ch, currentX, yPos);
      currentX += g.textWidth(ch);
    }

    // === 追加：枠の右側に絵文字を描く ===
    const emojiMargin = 20; // 枠の右端からの余白
    const rectRightX = g.width / 2 + (totalW + padding) / 2;
    const emojiYOffset = 10; // ← 絵文字を下にずらす量（10px）

    g.push();
    // 絵文字はカラー絵文字フォントへフォールバック（OS依存）
    g.textFont("Apple Color Emoji, Segoe UI Emoji, Noto Color Emoji, sans-serif");
    g.textAlign(p.LEFT, p.CENTER);
    g.textSize(textSizePx);
    g.noStroke();
    g.fill(255);
    g.text(this.emoji, rectRightX + emojiMargin, yPos + emojiYOffset);
    g.pop();
    // === 追加ここまで ===
  }
}
